<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
      <el-button type="danger" size="small" icon="el-icon-menu" :disabled="isBatch" plain @click="openBatch">批量操作</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" v-if="isBatch" width="55" fixed="left" align="center"></el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userCount" label="用户数量" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.userCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="vidCount" label="视频数量" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.vidCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tagsText" label="标签" align="center" min-width="200">
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tagsText" :key="i" class="tagBox">
            <el-tag type="success" size="mini" effect="plain" class="tags">{{
              "#" + tag
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0" v-if="isBatch">
      <el-button @click="giveUpBatch" type="danger" size="mini">取消批量操作</el-button>
      <el-button @click="openBatchDelete" type="primary" size="mini">批量删除</el-button>
    </div>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="标题" prop="title" style="width: 400px">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector v-model="form.tags" :tagList="tagList"></tag-selector>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import TagSelector from "@/components/tagSelector";
export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        title: undefined,
        tags: [],
      },
      tagList: [], //标签列表：包含标签名称和标签id
      isBatch: false,
      dataIds: [],
      batchUpdateDialog: false,
      batchStatus: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getUserAssembleList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          if (this.isBatch) {
            this.restoreCheckedState();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    // 新增标签配置
    addAndEdit(param) {
      this.dialogVisible = true; // 打开新增、编辑对话框
      this.getTagList();
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const tags = this.form.tags.map((tagName) => {
            let id = "";
            this.tagList.map((tag) => {
              if (tag.name == tagName) {
                id = tag.id;
              }
            });
            return id;
          });
          let req = {
            title: this.form.title,
            tags: tags,
          };
          API.addUserAssemble(req).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogVisible = false;
              this.form.tags = [];
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.title}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: [param.id],
          };
          API.deleteUserAssemble(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.title = "";
      this.form.id = undefined;
      this.isBatch = false;
      this.dataIds = [];
      this.batchStatus = 0;
      this.batchUpdateDialog = false;
      this.$refs.multipleTable.clearSelection();
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // *******************批量操作*********************
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.dataIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    // 批量操作窗口
    openBatch() {
      this.isBatch = true;
    },
    // 取消批量操作
    giveUpBatch () {
      this.isBatch = false;
      this.dataIds = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 打开批量删除窗口
    openBatchDelete() {
      if (this.dataIds.length === 0) return this.$message.error("请至少选择一条数据");
      const ids = this.dataIds.map(item => item.id);
      // 确认删除提示
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const req = {
          id: ids
        };
        API.deleteUserAssemble(req).then(res => {
          if (res.code === 200) {
            this.getList();
            this.handleClose();
            this.$message.success("批量删除成功");
          } else {
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
        this.$message.success("取消成功");
      });
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.dataIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.dataIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      const tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.dataIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.dataIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.dataIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.dataIds = this.dataIds.concat(objArr);
      const tempDatas = new Set(this.dataIds);
      this.dataIds = Array.from(tempDatas);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
